import * as React from 'react';
import { Checkbox } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import DoneIcon from '@mui/icons-material/Done';
import { DialogImage } from '../SEPlayTypes';
import List from '@mui/material/List';
import Tooltip from '@mui/material/Tooltip';

type SEPlayAddImagesProps = {
    image: DialogImage;
    handleAddImage: () => void;
    handleUncheckedImage: () => void;
    addTooltipLabel: string;
    removeTooltipLabel: string;
};

const SEPlayAddDialogListItem = (props: SEPlayAddImagesProps) => {
    let { image, handleAddImage, handleUncheckedImage, addTooltipLabel, removeTooltipLabel } =
        props;

    const [isChecked, setIsChecked] = React.useState(false);

    const handleOnChange = (e) => {
        if (e.target.checked) {
            handleAddImage();
            setIsChecked(true);
        }
        if (e.target.checked === false) {
            handleUncheckedImage();
            setIsChecked(false);
        }
    };

    return (
        <List
            key={image.thumbnail}
            sx={{
                listStyle: 'none',
                display: 'inline-block',
                width: 'auto',
                height: '200px',
                margin: '12px 24px 0 0'
            }}
        >
            <Box sx={{ position: 'relative' }}>
                <img width="auto" height="200px" src={image.thumbnail} alt="image" />
                <Tooltip
                    title={!isChecked ? addTooltipLabel : removeTooltipLabel}
                    componentsProps={{ tooltip: { sx: { fontSize: '14px' } } }}
                >
                    <Checkbox
                        inputProps={{ 'aria-label': 'add-image-checkbox', role: 'checkbox' }}
                        sx={{
                            height: '40px',
                            width: '40px',
                            position: 'absolute',
                            right: '5%',
                            bottom: '5%',
                            backgroundColor: '#7DAB9B',
                            '&:hover': {
                                backgroundColor: '#4F7C6D'
                            }
                        }}
                        icon={<AddIcon sx={{ height: '40px', width: '40px' }} />}
                        checkedIcon={
                            <DoneIcon sx={{ height: '40px', width: '40px', color: 'white' }} />
                        }
                        onChange={(e) => handleOnChange(e)}
                    />
                </Tooltip>
            </Box>
        </List>
    );
};
export default SEPlayAddDialogListItem;
